import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'sg-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent {

  contentScreen = false;
  @Input() randomQuizvraag: number;
  @Output() quizChange = new EventEmitter();

  handelKeuzeSchermAf($event) {
    if ($event != null) {
      this.contentScreen = false;
      this.quizChange.emit(true);
    } else {
      this.contentScreen = false;
      this.quizChange.emit(null);
    }
  }

  closePopover() {
    this.quizChange.emit(null);
  }
}
